import ApiService from '@/api/service';
import {
  SETTINGS_URL
} from '@/api/constants';

export default {
  get() {
    return ApiService.get(SETTINGS_URL);
  },
  update(settings) {
    return ApiService.put(SETTINGS_URL, settings);
  }
}